import React from 'react';
import { Link } from 'react-router-dom';

const LAST_UPDATED = '1 May 2026'; // update when needed

const DeleteAccountPage: React.FC = () => (
  <main className="container">
    <header style={{ paddingTop: '0', paddingBottom: '0.5rem' }}>
      <Link to="/" className="back-home-link" aria-label="Back to home">← Back to home</Link>
    </header>

    <article className="section" style={{ background: '#fff' }}>
      <h1>Delete Your Sparki Account</h1>
      <p><em>Last updated: {LAST_UPDATED}</em></p>

      <p>
        You can request deletion of your Sparki account and associated personal data at any time.
        This page explains how to request account deletion and what data may be removed or retained.
      </p>

      <h2>How to request account deletion</h2>
      <p>
        To request deletion of your account, email us at{' '}
        <a className="footer-link" href="mailto:support@sparkiapp.com?subject=Account%20Deletion%20Request">
          support@sparkiapp.com
        </a>{' '}
        with the subject line <strong>Account Deletion Request</strong>.
      </p>

      <p>Please include:</p>
      <ul>
        <li>The email address registered to your Sparki account.</li>
        <li>Whether your account is a customer account, garage account, or both.</li>
        <li>Confirmation that you want your account and associated data deleted.</li>
      </ul>

      <h2>What data will be deleted</h2>
      <p>Where applicable, we will delete or anonymise personal data associated with your account, including:</p>
      <ul>
        <li>Your account profile information, such as name, email address, and phone number.</li>
        <li>Vehicle details linked to your account.</li>
        <li>Booking records associated with your account, where deletion is appropriate.</li>
        <li>Messages, enquiries, and quote-related data linked to your account, where deletion is appropriate.</li>
        <li>Push notification tokens linked to your account.</li>
      </ul>

      <h2>Data we may need to retain</h2>
      <p>
        Some information may be retained where necessary for legal, accounting, security, fraud prevention,
        dispute resolution, or legitimate business record purposes. For example, garages may need to retain
        certain booking, invoice, or customer records to meet legal or accounting obligations.
      </p>

      <h2>How long deletion takes</h2>
      <p>
        We aim to process account deletion requests within 7 days. If we need more information to verify
        your request or identify your account, we may contact you using the email address you provide.
      </p>

      <h2>Questions</h2>
      <p>
        If you have any questions about account deletion or how Sparki handles personal data, contact us at{' '}
        <a className="footer-link" href="mailto:support@sparkiapp.com">support@sparkiapp.com</a>.
      </p>
    </article>
  </main>
);

export default DeleteAccountPage;